import { Controller } from '@hotwired/stimulus'

// Auto-submits the fleet filter form when any input inside it changes,
// avoiding inline `onchange=` handlers that the CSP forbids.
export default class extends Controller {
  submit() {
    this.element.submit()
  }
}
